var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_101_3458)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 31,
    r: 22,
    fill: "#22E9C5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 31,
    r: 23,
    stroke: "white",
    strokeWidth: 2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 28C17 31.94 18.9977 35.3961 22 37.3388V34.8265C20.1719 33.1872 19 30.7548 19 28C19 22.9605 22.9218 19 27.6083 19C31.5839 19 35.0091 21.85 35.9569 25.7911L35.9599 25.7899C36.0937 26.3367 36.1791 26.9037 36.2108 27.4855C36.8339 27.1732 37.5272 27 38.2493 27C40.8053 27 43 29.1696 43 32C43 34.1518 41.7314 35.9218 40 36.6467V38.7623C42.8796 37.9627 45 35.2381 45 32C45 28.134 41.9776 25 38.2493 25C38.1054 25 37.9626 25.0047 37.821 25.0139C36.5661 20.3898 32.469 17 27.6083 17C21.7495 17 17 21.9249 17 28ZM32.2565 39.5204L33 39L32.2565 38.4796L32.4142 37.5858L31.5204 37.7435L31 37L30.4796 37.7435L29.5858 37.5858L29.7435 38.4796L29 39L29.7435 39.5204L29.5858 40.4142L30.4796 40.2565L31 41L31.5204 40.2565L32.4142 40.4142L32.2565 39.5204ZM29.8284 35L29.0849 35.5204L29.2426 36.4142L28.3489 36.2565L27.8284 37L27.308 36.2565L26.4142 36.4142L26.572 35.5204L25.8284 35L26.572 34.4796L26.4142 33.5858L27.308 33.7435L27.8284 33L28.3489 33.7435L29.2426 33.5858L29.0849 34.4796L29.8284 35ZM29.0849 43.5204L29.8284 43L29.0849 42.4796L29.2426 41.5858L28.3489 41.7435L27.8284 41L27.308 41.7435L26.4142 41.5858L26.572 42.4796L25.8284 43L26.572 43.5204L26.4142 44.4142L27.308 44.2565L27.8284 45L28.3489 44.2565L29.2426 44.4142L29.0849 43.5204ZM39 39L38.2565 39.5204L38.4142 40.4142L37.5204 40.2565L37 41L36.4796 40.2565L35.5858 40.4142L35.7435 39.5204L35 39L35.7435 38.4796L35.5858 37.5858L36.4796 37.7435L37 37L37.5204 37.7435L38.4142 37.5858L38.2565 38.4796L39 39ZM35.0849 35.5204L35.8284 35L35.0849 34.4796L35.2426 33.5858L34.3489 33.7435L33.8284 33L33.308 33.7435L32.4142 33.5858L32.572 34.4796L31.8284 35L32.572 35.5204L32.4142 36.4142L33.308 36.2565L33.8284 37L34.3489 36.2565L35.2426 36.4142L35.0849 35.5204ZM35.8284 43L35.0849 43.5204L35.2426 44.4142L34.3489 44.2565L33.8284 45L33.308 44.2565L32.4142 44.4142L32.572 43.5204L31.8284 43L32.572 42.4796L32.4142 41.5858L33.308 41.7435L33.8284 41L34.3489 41.7435L35.2426 41.5858L35.0849 42.4796L35.8284 43ZM26.0849 39.5204L26.8284 39L26.0849 38.4796L26.2426 37.5858L25.3489 37.7435L24.8284 37L24.308 37.7435L23.4142 37.5858L23.572 38.4796L22.8284 39L23.572 39.5204L23.4142 40.4142L24.308 40.2565L24.8284 41L25.3489 40.2565L26.2426 40.4142L26.0849 39.5204Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_101_3458",
    x: 0.421053,
    y: 0.421053,
    width: 61.1579,
    height: 61.1579,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.28947
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.53849 0 0 0 0 0.567513 0 0 0 0 0.6125 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_101_3458"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_101_3458",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHail);
export default __webpack_public_path__ + "static/media/hail.1652e765b655d789f7d937ea16bd4ae2.svg";
export { ForwardRef as ReactComponent };